import {DBTables} from "../Pages/CreateNew/CreateNewConstant";

export enum DBType {
    DEV = "DEV",
    QA = "QA",
    PROD = "PROD",
}

class DBServices {

    private static _instance: DBServices;

    private _dbType: DBType = DBType.QA;

    private constructor() {}

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    public get dbType() {
        return this._dbType;
    }

    public get dbName() {
        if (this.dbType === DBType.DEV) {
            return DBTables.TEST_GROUP_DEV;
        } else if (this.dbType === DBType.PROD) {
            return DBTables.TEST_GROUP_PROD
        }

        return DBTables.TEST_GROUP_QA;
    }

    public dbNameByType(dbType?: DBType) {
        if (dbType === DBType.DEV) {
            return DBTables.TEST_GROUP_DEV;
        } else if (dbType === DBType.PROD) {
            return DBTables.TEST_GROUP_PROD
        }

        return DBTables.TEST_GROUP_QA;
    }

}

const dbService = DBServices.Instance;

export default dbService;